import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.scss';

import facebookIcon from '../../assets/images/icons/icon-facebook.svg';
import youtubeIcon from '../../assets/images/icons/icon-youtube.png';
import instagramIcon from '../../assets/images/icons/icon-instagram.png';

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer__container">
                <div className="footer__grid">
                    {/* Column 1: About */}
                    <div className="footer__col">
                        <h3 className="footer__heading">{t('church_name')}</h3>
                        <p className="footer__text">
                            {t('hero_title')}
                        </p>
                    </div>

                    {/* Column 2: Navigation */}
                    <div className="footer__col">
                        <h3 className="footer__heading">{t('resources')}</h3>
                        <nav className="footer__nav" aria-label="Footer navigation">
                            <Link to="/" className="footer__link">{t('home')}</Link>
                            <Link to="/about" className="footer__link">{t('about_us')}</Link>
                            <Link to="/join" className="footer__link">{t('join_in_person')}</Link>
                            <Link to="/contact" className="footer__link">{t('contacts')}</Link>
                        </nav>
                    </div>

                    {/* Column 3: Contact */}
                    <div className="footer__col">
                        <h3 className="footer__heading">{t('contact_information')}</h3>
                        <p className="footer__text">
                            {t('church_address_line1')}<br />
                            {t('church_address_line2')}
                        </p>
                        <p className="footer__text">
                            {t('sunday')}<br />
                            {t('service_english')}<br />
                            {t('service_ukrainian')}
                        </p>
                    </div>

                    {/* Column 4: Social */}
                    <div className="footer__col">
                        <h3 className="footer__heading">{t('connect_with_us')}</h3>
                        <div className="footer__social">
                            <a
                                href="https://www.facebook.com/thruChristalone/"
                                className="footer__social-link"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={facebookIcon} alt="" className="footer__social-icon" />
                            </a>
                            <a
                                href="https://www.youtube.com/c/RegenerationChurch"
                                className="footer__social-link"
                                aria-label="YouTube"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={youtubeIcon} alt="" className="footer__social-icon" />
                            </a>
                            <a
                                href="https://www.instagram.com/regeneration_church"
                                className="footer__social-link"
                                aria-label="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={instagramIcon} alt="" className="footer__social-icon" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="footer__copyright">
                    <p>{t('copyright', { year: currentYear })}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
